import React from "react";
import { BigFormModal } from "@/components/ui/big-form-modal";
import { ScrollArea } from "@/components/ui/scroll-area";
import termsRaw from "@/assets/legal/terms/latest.txt?raw";

const renderTermsElements = (raw: string) => {
  const lines = raw.split(/\r?\n/);
  let firstLineRendered = false;
  let inList = false;
  let listItems: React.ReactNode[] = [];
  let listIndex = 0;

  const elements: React.ReactNode[] = [];

  const flushList = () => {
    if (inList && listItems.length > 0) {
      elements.push(
        <ul key={`terms-list-${listIndex++}`} className="list-disc" style={{ paddingLeft: 20 }}>
          {listItems}
        </ul>
      );
    }
    inList = false;
    listItems = [];
  };

  for (let i = 0; i < lines.length; i++) {
    const rawLine = lines[i];
    const line = rawLine.trim();

    if (line.length === 0) {
      // blank line ends any open list
      flushList();
      continue;
    }

    // Bullet line starts with •
    if (/^•\s?/.test(line)) {
      if (!inList) {
        inList = true;
        listItems = [];
      }
      const liContent = line.replace(/^•\s?/, '').trim();
      listItems.push(
        <li key={`terms-li-${i}`} dangerouslySetInnerHTML={{ __html: liContent }} />
      );
      continue;
    }

    // Non-bullet line: ensure any open list is flushed
    flushList();

    if (!firstLineRendered) {
      elements.push(
        <p key={`terms-${i}`} dangerouslySetInnerHTML={{ __html: line }} />
      );
      firstLineRendered = true;
      continue;
    }

    if (/^\d+\.\s/.test(line) || /^\d+\.$/.test(line)) {
      elements.push(
        <h3
          key={`terms-${i}`}
          className="text-base font-semibold mt-6"
          dangerouslySetInnerHTML={{ __html: line }}
        />
      );
    } else {
      elements.push(
        <p
          key={`terms-${i}`}
          className="pt-6"
          dangerouslySetInnerHTML={{ __html: line }}
        />
      );
    }
  }

  // Close any trailing list
  flushList();

  return elements.length > 0 ? elements : null;
};
interface TermsOfUseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept?: () => void;
}
const TermsOfUseModal: React.FC<TermsOfUseModalProps> = ({
  isOpen,
  onClose,
  onAccept
}) => {
  // Determine if this is interactive mode (onAccept provided) or read-only mode
  const isInteractiveMode = !!onAccept;
  
  const handleSave = () => {
    if (isInteractiveMode) {
      // Interactive mode: call onAccept then close
      onAccept?.();
    }
    onClose();
  };

  const termsElements = renderTermsElements(termsRaw);

  return <BigFormModal 
    isOpen={isOpen} 
    onClose={onClose} 
    title="Terms of Use for KidsBooked Pro" 
    hideActions={false} 
    extraActions={null} 
    cancelLabel={undefined} 
    saveLabel={isInteractiveMode ? "I accept" : "Close"} 
    showSaveButton={true} 
    showCancelButton={false} 
    onSave={handleSave}
  >
      <ScrollArea className="pr-4">
        <div className="prose prose-slate max-w-none">
          {termsElements}
        </div>
      </ScrollArea>
    </BigFormModal>;
};
export default TermsOfUseModal;